<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="overlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle">Content Analytics</h4>
        <p class="subtitle">{{contentTitle[lang]}}</p>
        <div class="loading" v-if="loading">
          <div>
            <h4>Analytics has been disabled</h4>
            <p>Please contact developer to unlock analytics features</p>
          </div>
        </div>
        <div class="listingSc" v-else>
          <div class="listingCnt">
            <div :class="{listingInfo: true, page1: true,
              active: !isPage2, page3: isPage3, page4: isPage4}">
              <div class="alHeader">
                <div class="onlineVisitor">
                  <h4>Online Visitor</h4>
                  <h5>{{online.toLocaleString('id')}}</h5>
                  <p>How many peoples currently opening this content</p>
                </div>
                <div class="pageRankCnt">
                  <div class="pageRank">
                    <h4>Average stay in page</h4>
                    <div class="sources" v-if="detail.pageRank.length > 0">
                      <div class="sourceItem" v-for="(item, index) in detail.pageRank" :key="index">
                        <div class="source" v-if="item.page === 1 || item.page % 2 === 0">
                          Page {{item.page}}</div>
                        <div class="source" v-else>Page {{item.page - 1}} - {{item.page}}</div>
                        <div class="count">{{item.avgTime | moment('mm:ss')}}</div>
                        <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                      </div>
                    </div>
                    <div class="noData" v-else>No data available</div>
                    <div class="moreCnt" v-if="detail.pageRank.length > 0">
                      <div class="moreBtn" v-on:click="allPages">
                        View all pages
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="alBody">
                <div class="analyticContent">
                  <div class="analyticItem">
                    <p v-if="detail.viewCount">{{detail.viewCount.toLocaleString('id')}}</p>
                    <p v-else>0</p>
                    Total impressions
                    <span>How many times people see this content on amway.</span>
                  </div>
                  <div class="analyticItem">
                    <p v-if="!detail.engagementCount">0</p>
                    <p v-else>{{detail.engagementCount.toLocaleString('id')}}</p>
                    Total engagements
                    <span>How many peoples open this content.</span>
                  </div>
                  <div class="analyticItem">
                    <p v-if="!detail.totalDownload">0</p>
                    <p v-else>{{detail.totalDownload.toLocaleString('id')}}</p>
                    Total Download
                    <span>How many times user download the pdf.</span>
                  </div>
                  <div class="analyticItem" v-if="1>2">
                    <p v-if="!detail.whatsappDelivered">0</p>
                    <p v-else>{{detail.whatsappDelivered.toLocaleString('id')}}/{{detail
                      .totalWhatsapp.toLocaleString('id')}}</p>
                    Whatsapp delivered
                    <span>How many whatsapp message has been delivered for this content.</span>
                  </div>
                  <div class="analyticItem">
                    <p v-if="!detail.smsDelivered">0</p>
                    <p v-else>{{detail.smsDelivered.toLocaleString('id')}}/{{detail
                      .totalSms.toLocaleString('id')}}</p>
                    SMS delivered
                    <span>How many SMS message has been delivered for this content.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="listingInfo page2">
              <div class="page2Cnt">
                <div class="pageRank ontop onleft">
                  <h4>Analytics by user's type</h4>
                  <div class="sources" v-if="detail.roles.length > 0">
                    <div class="sourceItem" v-for="(item, index) in detail.roles" :key="index">
                      <div class="source">{{item.name}}</div>
                      <div class="count">{{item.total}} views</div>
                      <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                </div>
                <div class="pageRank ontop onright">
                  <h4>By user's city</h4>
                  <div class="sources" v-if="detail.cities.length > 0">
                    <div class="sourceItem" v-for="(city, index) in detail.cities" :key="index">
                      <div class="source">{{city.city}}</div>
                      <div class="count">{{city.total.toLocaleString('id')}}</div>
                      <div class="percentage" :style="{width: `${city.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="detail.cities.length > 0">
                    <div class="moreBtn" v-on:click="allCity">View all cities</div></div>
                </div>
                <div class="pageRank onleft">
                  <h4>Visits per page</h4>
                  <div class="sources" v-if="detail.visitPerPage.length > 0">
                    <div class="sourceItem"
                      v-for="(share, index) in detail.visitPerPage" :key="index">
                      <div class="source" v-if="share.page === 1 || share.page % 2 === 0">
                        Page {{share.page}}</div>
                      <div class="source" v-else>Page {{share.page - 1}} - {{share.page}}</div>
                      <div class="count">{{share.total.toLocaleString('id')}}</div>
                      <div class="percentage" :style="{width: `${share.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="detail.visitPerPage.length > 0">
                    <div class="moreBtn" v-on:click="allVisitPerPage">View all pages</div></div>
                </div>
                <div class="pageRank onright">
                  <h4>Share</h4>
                  <div class="sources" v-if="detail.share.length > 0">
                    <div class="sourceItem" v-for="(share, index) in detail.share" :key="index">
                      <div class="source" v-if="share.page === 1 || share.page % 2 === 0">
                        Page {{share.page}}</div>
                      <div class="source" v-else>Page {{share.page - 1}} - {{share.page}}</div>
                      <div class="count">{{share.shareCount.toLocaleString('id')}}</div>
                      <div class="percentage" :style="{width: `${share.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="detail.share.length > 0">
                    <div class="moreBtn" v-on:click="allShare">View all pages</div></div>
                </div>
              </div>
            </div>
            <div class="listingInfo page3">
              <div class="page2Cnt">
                <div class="pageRank ontop onleft prLoading" v-if="vAboLoading"></div>
                <div class="pageRank ontop onleft" v-else>
                  <h4>Visits by ABO</h4>
                  <div class="sources" v-if="dataAbo.length > 0">
                    <div class="sourceItem" v-for="(item, index) in dataAbo" :key="index">
                      <div class="source" v-if="item.page === 1 || item.page % 2 === 0">
                        Page {{item.page}}</div>
                      <div class="source" v-else>Page {{item.page - 1}} - {{item.page}}</div>
                      <div class="count">{{item.total}} views</div>
                      <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="dataAbo.length > 0">
                    <div class="moreBtn" v-on:click="allAbo">View all visits</div></div>
                </div>
                <div class="pageRank ontop onright prLoading" v-if="vNaboLoading"></div>
                <div class="pageRank ontop onright" v-else>
                  <h4>Visits by NABO</h4>
                  <div class="sources" v-if="dataNabo.length > 0">
                    <div class="sourceItem" v-for="(item, index) in dataNabo" :key="index">
                      <div class="source" v-if="item.page === 1 || item.page % 2 === 0">
                        Page {{item.page}}</div>
                      <div class="source" v-else>Page {{item.page - 1}} - {{item.page}}</div>
                      <div class="count">{{item.total}} views</div>
                      <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="dataNabo.length > 0">
                    <div class="moreBtn" v-on:click="allNabo">View all visits</div></div>
                </div>
                <div class="pageRank onleft prLoading" v-if="vPrioritasLoading"></div>
                <div class="pageRank onleft" v-else>
                  <h4>Visits by Pelanggan Prioritas</h4>
                  <div class="sources" v-if="dataPrioritas.length > 0">
                    <div class="sourceItem" v-for="(item, index) in dataPrioritas" :key="index">
                      <div class="source" v-if="item.page === 1 || item.page % 2 === 0">
                        Page {{item.page}}</div>
                      <div class="source" v-else>Page {{item.page - 1}} - {{item.page}}</div>
                      <div class="count">{{item.total}} views</div>
                      <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="dataPrioritas.length > 0">
                    <div class="moreBtn" v-on:click="allPrioritas">View all visits</div></div>
                </div>
                <div class="pageRank onright prLoading" v-if="vPlatinumLoading"></div>
                <div class="pageRank onright" v-else>
                  <h4>Visits by Platinum Above</h4>
                  <div class="sources" v-if="dataPlatinum.length > 0">
                    <div class="sourceItem" v-for="(item, index) in dataPlatinum" :key="index">
                      <div class="source" v-if="item.page === 1 || item.page % 2 === 0">
                        Page {{item.page}}</div>
                      <div class="source" v-else>Page {{item.page - 1}} - {{item.page}}</div>
                      <div class="count">{{item.total}} views</div>
                      <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="dataPlatinum.length > 0">
                    <div class="moreBtn" v-on:click="allPlatinum">View all visits</div></div>
                </div>
              </div>
            </div>
            <div class="listingInfo page4">
              <div class="page2Cnt">
                <div class="pageRank ontop onleft prLoading" v-if="vUnknownLoading"></div>
                <div class="pageRank ontop onleft" v-else>
                  <h4>Visits by Unknown</h4>
                  <div class="sources" v-if="dataUnknown.length > 0">
                    <div class="sourceItem" v-for="(item, index) in dataUnknown" :key="index">
                      <div class="source" v-if="item.page === 1 || item.page % 2 === 0">
                        Page {{item.page}}</div>
                      <div class="source" v-else>Page {{item.page - 1}} - {{item.page}}</div>
                      <div class="count">{{item.total}} views</div>
                      <div class="percentage" :style="{width: `${item.percentage}%`}"></div>
                    </div>
                  </div>
                  <div class="noData" v-else>No data available</div>
                  <div class="moreCnt" v-if="dataUnknown.length > 0">
                    <div class="moreBtn" v-on:click="allUnknown">View all visits</div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <div :class="{pn: true, prev: true, disabled: !isPage2}"
            v-on:click="goBack">Previous</div>
          <div :class="{pn: true, next: true, disabled: isPage4}"
            v-on:click="goNext">Next</div>
        </div>
        <div class="pager">
          <div :class="{p: true, active: !isPage2 && !isPage3 && !isPage4}"
            v-on:click="isPage2 = false; isPage3 = false; isPage4 = false"></div>
          <div :class="{p: true, active: isPage2 && !isPage3 && !isPage4}"
            v-on:click="isPage2 = true; isPage3 = false; isPage4 = false"></div>
          <div :class="{p: true, active: isPage3 && !isPage4}"
            v-on:click="isPage3 = true; isPage4 = false; loadP3()"></div>
          <div :class="{p: true, active: isPage4}"
            v-on:click="isPage4 = true; loadP4()"></div>
        </div>
      </div>
      <AnalyticDetail ref="analyticDetail"/>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import AnalyticDetail from '@/components/AnalyticDetail.vue';

export default {
  components: { AnalyticDetail },
  data() {
    return {
      show: false,
      next: null,
      loading: true,
      contentTitle: '',
      detail: null,
      isPage2: false,
      isPage3: false,
      isPage4: false,
      timer: null,
      online: 0,
      content: null,
      vAboLoading: true,
      vNaboLoading: true,
      vPlatinumLoading: true,
      vPrioritasLoading: true,
      vUnknownLoading: true,
      dataAbo: [],
      dataNabo: [],
      dataPlatinum: [],
      dataPrioritas: [],
      dataUnknown: [],
      p3Loaded: false,
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    open(d, n) {
      this.content = d;
      this.contentTitle = d.title;
      this.loading = true;
      this.show = true;
      this.vAboLoading = true;
      this.vNaboLoading = true;
      this.vPlatinumLoading = true;
      this.vPrioritasLoading = true;
      this.dataAbo = [];
      this.dataNabo = [];
      this.dataPlatinum = [];
      this.dataPrioritas = [];
      this.isPage2 = false;
      this.isPage3 = false;
      this.p3Loaded = false;
      this.p4Loaded = false;
      this.getData(d);
      this.countOnline(d);
    },
    goNext() {
      if (!this.isPage2) {
        this.isPage2 = true;
      } else if (!this.isPage3) {
        this.isPage3 = true;
        this.loadP3();
      } else {
        this.isPage4 = true;
        this.loadP4();
      }
    },
    goBack() {
      if (this.isPage4) this.isPage4 = false;
      else if (this.isPage3) this.isPage3 = false;
      else this.isPage2 = false;
    },
    loadP3() {
      if (this.p3Loaded) return;
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/abo`)).then((r) => {
        this.p3Loaded = false;
        this.vAboLoading = false;
        this.dataAbo = (r.data.status === 200) ? r.data.data : [];
      });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/nabo`)).then((r) => {
        this.p3Loaded = false;
        this.vNaboLoading = false;
        this.dataNabo = (r.data.status === 200) ? r.data.data : [];
      });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/platinum`)).then((r) => {
        this.p3Loaded = false;
        this.vPlatinumLoading = false;
        this.dataPlatinum = (r.data.status === 200) ? r.data.data : [];
      });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/prioritas`)).then((r) => {
        this.p3Loaded = false;
        this.vPrioritasLoading = false;
        this.dataPrioritas = (r.data.status === 200) ? r.data.data : [];
      });
    },
    loadP4() {
      if (this.p4Loaded) return;
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/unknown`)).then((r) => {
        this.p4Loaded = false;
        this.vUnknownLoading = false;
        this.dataUnknown = (r.data.status === 200) ? r.data.data : [];
      });
    },
    countOnline(d) {
      if (!this.show) return;
      this.$http.get(this.$config.uri(`content/${d.id}/online`)).then((r) => {
        this.online = (r.data.status === 200) ? r.data.online : 0;
        this.timer = setTimeout(() => {
          this.countOnline(d);
        }, 5000);
      });
    },
    getData(d) {
      this.$http.get(this.$config.uri(`content/${d.id}/analytics`)).then((r) => {
        if (r.data.status !== 200) {
          this.close();
          return;
        }
        this.detail = r.data.data;
        this.loading = false;
      });
    },
    close(b) {
      if (this.timer) clearTimeout(this.timer);
      this.show = false;
    },
    allPages() {
      this.$refs.analyticDetail.open({ title: 'Average stay in page' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/stay`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allCity() {
      this.$refs.analyticDetail.open({ title: 'User\'s city' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/city`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allShare() {
      this.$refs.analyticDetail.open({ title: 'Share per page' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/share`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allVisitPerPage() {
      this.$refs.analyticDetail.open({ title: 'Visits per page' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/vpp`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allAbo() {
      this.$refs.analyticDetail.open({ title: 'Visits by ABO' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/abo?all=yes`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allNabo() {
      this.$refs.analyticDetail.open({ title: 'Visits by NABO' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/nabo?all=yes`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allPrioritas() {
      this.$refs.analyticDetail.open({ title: 'Visits by Pelanggan Prioritas' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/prioritas?all=yes`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allPlatinum() {
      this.$refs.analyticDetail.open({ title: 'Visits by Platinum Above' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/platinum?all=yes`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
    allUnknown() {
      this.$refs.analyticDetail.open({ title: 'Visits by Unknown' });
      this.$http.get(this.$config.uri(`content/${this.content.id}/al/role/unknown?all=yes`)).then((r) => {
        this.$refs.analyticDetail.setData((r.data.status === 200) ? r.data.data : []);
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .listingSc{
    width: 680px;
    overflow: hidden;
  }
  .listingCnt{
    position: relative;
    width: 2720px;
    display: flex;
    .listingInfo{
      width: 25%;
      transition: all .3s ease;
      &.page1{
        margin-left: -680px;
        &.active{
          margin-left: 0;
        }
        &.page3{
          margin-left: -1360px;
        }
        &.page4{
          margin-left: -2040px;
        }
      }
      .page2Cnt{
        display: flex;
        flex-wrap: wrap;
        .pageRank{
          width: 50%;
          box-sizing: border-box;
          &.ontop{
            padding-bottom: 10px;
          }
          &.onleft{
            padding-right: 15px;
          }
          &.onright{
            padding-left: 15px;
          }
          &.download{
            display: none;
          }
          &.prLoading{
            height: 224px;
            background-color: #f5f5f5;
            background-image: url(../assets/loading-2.svg);
            background-position: center;
            background-size: 46px auto;
            background-repeat: no-repeat;
            // border: #eee 1px solid;
            border-radius: 10px;
            width: calc(50% - 10px);
            &.ontop{
              margin-bottom: 10px;
            }
            &.onleft{
              margin-right: 5px;
            }
            &.onright{
              margin-left: 5px;
            }
          }
          h4{
            margin: 0;
            font-size: 20px;
          }
        }
      }
    }
  }
  .pagination{
    position: absolute;
    bottom: 16px; right: 40px;
    display: flex;
    .pn{
      font-size: 16px;
      color: #0057d8;
      font-weight: 600;
      padding: 4px 20px 6px;
      border-radius: 50px;
      position: relative;
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
      &:before{
        position: absolute;
        height: 100%; top: 0;
        content: "";
        width: 20px;
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.next{
        padding-right: 40px;
        &:before{
          right: 12px;
          background-image: url(../assets/next-arrow-blue.png);
        }
      }
      &.prev{
        padding-left: 40px;
        &:before{
          left: 12px;
          background-image: url(../assets/back-arrow-blue.png);
        }
      }
      &.disabled{
        color: #999;
        cursor: default;
        background-color: #fff;
        &:before{
          opacity: .4;
        }
        &.next{
          &:before{
            background-image: url(../assets/next-arrow-black.png);
          }
        }
        &.prev{
          &:before{
            background-image: url(../assets/back-arrow.png);
          }
        }
      }
    }
  }
  .pager{
    position: absolute;
    left: 50%; bottom: 26px;
    display: flex;
    transform: translateX(-50%);
    .p{
      width: 10px; height: 10px;
      background-color: #ccc;
      border-radius: 50%;
      margin: 0 5px;
      cursor: pointer;
      &:hover{
        background-color: #999;
      }
      &.active{
        background-color: #0e5dd2;
      }
    }
  }

  .modal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.5);
      z-index: 1;
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 680px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 60px 50px;
      .loading{
        height: 400px;
        // background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-size: 46px auto;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #999;
        h4{
          font-size: 26px;
          font-weight: 600;
          margin: 0 0 6px;
        }
        p{
          margin: 0 0 20px;
          font-size: 18px;
        }
      }
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .modalTitle{
        font-size: 28px;
        margin: 0;
      }
      .subtitle{
        margin: 0 0 20px;
        font-size: 18px;
        color: #767676;
      }
      .noData{
        background-color: #f5f5f5;
        height: 180px;
        text-align: center;
        box-sizing: border-box;
        margin: 10px 0;
        border-radius: 5px;
        color: #999;
        font-size: 15px;
        padding-top: 74px;
      }
      .alHeader{
        display: flex;
        margin-bottom: 10px;
        .onlineVisitor{
          width: 240px;
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
          border-radius: 10px;
          text-align: center;
          padding: 22px 20px 0;
          box-sizing: border-box;
          min-height: 200px;
          h4{
            margin: 0;
            font-size: 20px;
          }
          h5{
            margin: 20px 0;
            font-size: 60px;
            font-weight: normal;
          }
          p{
            margin: 0;
            font-size: 14px;
            color: #767676;
          }
        }
        .pageRankCnt{
          width: calc(100% - 240px);
          display: flex;
          .pageRank{
            box-sizing: border-box;
            padding-left: 30px;
            width: 100%;
            // width: 50%;
            h4{
              margin: 0;
              font-size: 20px;
            }
          }
        }
      }
      .alBody{
        display: flex;
        .analyticContent{
          // width: calc(100% - 300px);
          width: 100%;
          // padding-right: 30px;
        }
        .pageRank{
          width: 300px;
          h4{
            margin: 0;
            font-size: 20px;
            padding-top: 20px;
          }
        }
      }
    }
  }
  .moreCnt{
    text-align: right;
    .moreBtn{
      color: #0057d8;
      font-weight: 600;
      position: relative;
      padding-right: 26px;
      cursor: pointer;
      display: inline-block;
      &:hover{
        color: #0067ff;
      }
      &:before{
        content: "";
        position: absolute;
        right: 0; top: 1px; bottom: 0; width: 16px;
        background-image: url(../assets/next-arrow-blue.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
  .sources{
    margin-bottom: 14px;
    .sourceItem{
      padding: 10px 0;
      display: flex;
      position: relative;
      .percentage{
        position: absolute;
        height: 4px;
        background-color: #0e5dd2;
        bottom: 0; left: 0;
        border-radius: 50px;
      }
      .source{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: auto;
        span{
          color: #767676;
        }
      }
      .count{
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }
  .analyticContent{
    padding-top: 20px;
    // margin-bottom: -30px;
    .analyticItem{
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 16px;
      p{
        margin: 0;
        margin-top: 2px;
        font-size: 30px;
        float: right;
        font-weight: 600;
      }
      span{
        display: block;
        font-size: 14px;
        font-weight: normal;
        padding-right: 160px;
        color: #767676;
      }
    }
  }
</style>
